import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, ShoppingCart, CreditCard } from 'lucide-react';
import api from "../../api/axios"; // Adjust path to your axios instance
import { Helmet } from 'react-helmet-async';



const ProductPage = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isInCart, setIsInCart] = useState(false);

  const navigate = useNavigate();


  // Brand Colors from your original design
  const colors = {
    primary: "#FFAA00",
    secondary: "#8A8A89",
  };



  const BACKEND_BASE = process.env.REACT_APP_BACKEND_URL;

  // Helper to handle the double /storage/ path issue
  const getImageUrl = (path) => {
    if (!path) return "";
    if (path.startsWith('/storage')) {
      return `${BACKEND_BASE}${path}`;
    }
    return `${BACKEND_BASE}/storage/${path}`;
  };





  const getCart = () => {
    const cart = localStorage.getItem("my_cart");
    return cart ? JSON.parse(cart) : [];
  };


  const addToCart = () => {

    const cart = getCart();

    if (cart.includes(slug)) {
      alert("Produit déjà dans le panier");
      return;
    }

    cart.push(slug);
    localStorage.setItem("my_cart", JSON.stringify(cart));
    setIsInCart(true);

    window.dispatchEvent(new Event("cartUpdated"));



  };






  const addToCart2 = () => {

    const cart = getCart();

    if (cart.includes(slug)) {

      return;
    }

    cart.push(slug);
    localStorage.setItem("my_cart", JSON.stringify(cart));
    setIsInCart(true);

    window.dispatchEvent(new Event("cartUpdated"));



  };



  const buy_now = () => {

    addToCart2();

    setTimeout(() => {

      navigate("/cart");

    }, 1000)

  }






  useEffect(() => {



    const isProductInCart = (slug) => {
      const cart = getCart();
      return cart.includes(slug);
    };


    const fetchProduct = async () => {
      try {
        const res = await api.get('/products');
        const foundProduct = res.data.data.find(p => p.slug === slug);

        if (foundProduct) {
          setProduct(foundProduct);
          setSelectedImage(foundProduct.main_image);
        }

        // ✅ check cart here
        setIsInCart(isProductInCart(slug));

      } catch (err) {
        console.error("Error fetching product:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [slug]);








  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="animate-spin text-[#FFAA00]" size={40} />
    </div>
  );

  if (!product) return <div className="min-h-screen flex items-center justify-center font-bold">Produit non trouvé.</div>;

  // Combine Main Image and Gallery Images
  const allImages = [product.main_image, ...product.images.map(img => img.image_path)];


  return (
    <div className="min-h-screen drop-shadow-2xl py-12 px-4 sm:px-6 lg:px-8 font-sans">


      <Helmet>
        {/* Dynamic Title: Product Name + Brand */}
        <title>{`${product.title} | ${product.brand || 'Electro Titan'}`}</title>

        {/* Dynamic Description: First 150-160 chars of description */}
        <meta
          key="description" name="description"
          content={product.description?.substring(0, 155) || `Achetez ${product.title} au meilleur prix chez Electro Titan Maroc.`}
        />

        {/* Open Graph for WhatsApp/Facebook Sharing */}
        <meta key="og:title" property="og:title" content={product.title} />
        <meta key="og:description" property="og:description" content={product.description?.substring(0, 155)} />
        <meta key="og:image" property="og:image"  content={getImageUrl(product.main_image)} />
        <meta key="og:type" property="og:type" content="product" />
        <meta key="product:price:amount" property="product:price:amount" content={product.price} />
        <meta key="product:price:currency" property="product:price:currency" content="MAD" />
      </Helmet>




      <div className="w-full mx-auto overflow-hidden">
        <div className="flex flex-col lg:flex-row">

          {/* LEFT COLUMN: IMAGES (Using your original layout) */}
          <div className="lg:w-1/2 p-6 flex flex-col md:flex-row gap-4 bg-white">
            {/* Thumbnails */}
            <div className="order-2 md:order-1 flex md:flex-col gap-3 justify-center">
              {allImages.map((img, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedImage(img)}
                  className={`relative w-20 h-20 rounded-xl overflow-hidden border-2 transition-all ${selectedImage === img
                    ? `border-[${colors.primary}] scale-105`
                    : 'border-transparent opacity-60 hover:opacity-100'
                    }`}
                  style={{ borderColor: selectedImage === img ? colors.primary : 'transparent' }}
                >
                  <img src={getImageUrl(img)} alt="thumbnail" className="w-full h-full object-cover" />
                </button>
              ))}
            </div>

            {/* Main Image Container */}
            <div className="order-1 md:order-2 flex-1 relative bg-gray-50 rounded-2xl overflow-hidden flex items-center justify-center min-h-[450px]">
              <AnimatePresence mode="wait">
                <motion.img
                  key={selectedImage}
                  src={getImageUrl(selectedImage)}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 1.05 }}
                  transition={{ duration: 0.4 }}
                  className="max-w-full h-auto object-contain p-6"
                  alt="Product"
                />
              </AnimatePresence>

              {/* Dynamic Badge for New/Discount */}
              <div
                className="absolute top-4 left-4 text-white px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest shadow-sm"
                style={{ backgroundColor: product.discount > 0 ? '#ef4444' : colors.primary }}
              >
                {product.discount > 0 ? `-${product.discount}%` : 'Nouveau'}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: DETAILS (Using your original layout) */}
          {/* RIGHT COLUMN: DETAILS */}
          <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center bg-white">
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <span
                className="font-bold tracking-[0.2em] uppercase text-sm"
                style={{ color: colors.secondary }}
              >
                {product.brand || 'Electrotitan'}
              </span>

              <h1 className="text-4xl font-extrabold text-gray-900 mt-2 mb-4 leading-tight">
                {product.title}
              </h1>

              <div className="flex items-center gap-4 mb-8">
                <span className="text-4xl font-black" style={{ color: colors.primary }}>
                  {product.price} dh
                </span>
                {product.old_price && (
                  <span className="text-xl line-through" style={{ color: colors.secondary }}>
                    {product.old_price} dh
                  </span>
                )}
              </div>

              <div className="h-1 w-20 mb-8" style={{ backgroundColor: colors.primary }}></div>

              {/* THE FIX: Added white-space: pre-line */}
              <p
                className="text-gray-600 leading-relaxed mb-8 text-lg"
                style={{ whiteSpace: 'pre-line' }}
              >
                {product.description || "Aucune description disponible pour ce produit."}
              </p>

              {/* Technical Status */}
              {/* <div className="space-y-4 mb-10">
                <h3 className="text-sm font-black uppercase tracking-widest text-gray-400">
                  État du Stock
                </h3>
                <div className="flex items-center text-gray-700 font-medium">
                  <CheckCircle2 className="w-5 h-5 mr-2" style={{ color: product.stock > 0 ? colors.primary : '#ef4444' }} />
                  {product.stock > 0 ? `Disponible (${product.stock} unités)` : "En rupture de stock"}
                </div>
              </div> */}

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-4">

                <motion.button
                  onClick={() => buy_now()}
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  disabled={product.stock <= 0}
                  className="flex-1 py-4 rounded-xl font-bold uppercase tracking-widest transition-all shadow-lg hover:shadow-xl disabled:bg-gray-300"
                  style={{ backgroundColor: colors.primary, color: '#fff' }}
                >
                  <CreditCard className="inline mr-2" size={18} />
                  Acheter Maintenant
                </motion.button>

                <motion.button
                  onClick={addToCart}
                  whileHover={!isInCart ? { y: -2 } : {}}
                  whileTap={{ scale: 0.98 }}
                  disabled={product.stock <= 0 || isInCart}
                  className="flex-1 py-4 rounded-xl font-bold uppercase tracking-widest transition-all shadow-lg hover:shadow-xl"
                  style={{
                    backgroundColor: isInCart ? "#8A8A89" : colors.primary,
                    color: "#fff",
                    cursor: isInCart ? "not-allowed" : "pointer",
                  }}
                >
                  <ShoppingCart className="inline mr-2" size={18} />
                  {isInCart ? "Déjà au Panier" : "Ajouter au Panier"}
                </motion.button>


              </div>

              {/* <p className="text-center text-xs mt-6 font-bold" style={{ color: colors.secondary }}>
                LIVRAISON GRATUITE PARTOUT AU MAROC
              </p> */}
            </motion.div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default ProductPage;